const availableCardIcons = {
  amex: 'card-amex',
  diners: 'card-diners',
  discover: 'card-discover',
  jcb: 'card-jcb',
  mastercard: 'card-mastercard',
  visa: 'card-visa',
  unionPay: 'card-unionpay',
  unknown: 'card-sample-error',
  default: 'card-sample',
};

export default function cardImagePath(cardName = 'default') {
  return availableCardIcons[cardName.toLowerCase()] ? availableCardIcons[cardName.toLowerCase()] : availableCardIcons.default;
}
